import { usePudPeopleQuery } from "@graphql/api";
import Field from "@hudson/ui/components/FormFields/Field";
import Search from "@hudson/ui/components/FormFields/Search";
import FrameConfig from "@lib/classes/FrameConfig";
import { debugContext } from "@hudson/ui/lib";
import Session from "@lib/session";
import { useContext } from "react";

function PudPersonSelector({ className = "" }: { className?: string }): JSX.Element | null {
  const { debugMode } = useContext(debugContext);
  const {
    data = {},
    loading,
    error,
  } = usePudPeopleQuery({
    variables: {
      serviceAreaId: Session.getBooking().serviceArea,
      showToken: debugMode,
      tokenGroup: new FrameConfig().tokenGroup,
    },
  });
  const { config, content, pudPeople = [] } = data;

  let people: Array<{ value: string; label: string }> = [];
  if (pudPeople) {
    people = pudPeople.map((person: be.PudPerson) => ({
      value: person.id,
      label: (
        <div>
          {person.name && (
            <p className={`${person.address ? "font-semibold text-gray-900" : ""}`}>
              {person.name}
            </p>
          )}
          <p className={`${person.name ? "text-gray-500 text-sm" : ""}`}>{person.address}</p>
        </div>
      ),
      labelText: `${person.name || ""} ${person.address || ""}`.trim(),
    }));
  }

  if (!config?.pudsAsPeople || pudPeople.length === 0) return null;

  return (
    <Field
      className={`${className} z-[105]`}
      dataError={error}
      dataLoading={loading}
      fieldControl={(value, onChange, inError, onBlur) => (
        <Search
          filterOption={(option, inputValue) => {
            const searchValue = inputValue.toLowerCase();
            const labelText = option.data.labelText.toLowerCase();
            return labelText.includes(searchValue);
          }}
          inError={inError}
          noOptionsMessage={content?.beSelectNoOptions}
          onBlur={onBlur}
          onChange={onChange}
          options={people}
          placeholder={content?.bePudPersonLabel}
          value={value}
        />
      )}
      fieldName={"pudPerson"}
      labelClassName="text-sm"
    />
  );
}

export default PudPersonSelector;
